import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import noImage from "../../../../../../assets/images/settings/no-image.png";
import PriceTag from "../../../../../../assets/images/tagPrice.PNG";
import LoaderPost from "../../../../../Reuseable/LoaderPost";
import NotifyModalAdmin from "../NotifyGreetings/NotifyModalAdmin";
import "./NotifyGreetings.css";
import Nodata from "../../../../../../assets/Icon/Nodata.png";
import { serverInfo } from "../../../../../../App";
import { useContext } from "react";
import ReactPaginate from "react-paginate";
const NotifyGreetingsContent = () => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);
  const [loading, setloading] = useState(true);
  const [greeting, setGreeting] = useState({});
  const [greetingList, setGreetingList] = useState([]);
  const [Checked, setChecked] = useState([]);
  const [regGreId, setregGreId] = useState([]);
  const [modalShowl, setModalShowl] = useState(false);

    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = 5;
    const data = greetingList;

    useEffect(() => {
      const endOffset = itemOffset + itemsPerPage;
      setCurrentItems(data.slice(itemOffset, endOffset));
      setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, data]);

    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % data.length;
      setItemOffset(newOffset);
    };

  const getGreetingStatus = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get("/api/admin/greetings_star_status").then((res) => {
        if (res.data.status === 200) {
          setGreeting(res.data.greeting);
        } else {
          swal("error", "Data base Error", "error");
        }
        setloading(false);
      });
    });
  };

  const getAllGreetingReg = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get("/api/admin/greetings_register_list").then((res) => {
        if (res.data.status === 200) {
          setGreetingList(res.data.list);
        } else {
          swal("error", "Data base Error", "error");
        }
        setloading(false);
      });
    });
  };

  const handleCheckBox = (user_id, greetings_id) => {
    setChecked((prev) =>
      prev.includes(user_id) ? prev.filter((id) => id !== user_id) : [...prev, user_id]
    );
  
    setregGreId((prev) =>
      prev.includes(greetings_id) ? prev.filter((id) => id !== greetings_id) : [...prev, greetings_id]
    );
  };

  useEffect(() => {
    getGreetingStatus();
    getAllGreetingReg();
  }, [modalShowl]);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          {Object.keys(greeting).length != 0 ? (
            <>
              <div className="row mx-2">
                <div className="col-md-7 mb-3">
                  <div className="card card-bg p-2">
                    {" "}
                    <img
                      src={
                        greeting?.banner
                          ? imageCdnUrl+greeting?.banner
                          : noImage
                      }
                      alt=""
                      className=" img-fluid banner_re"
                    />
                  </div>
                </div>
                <div className="col-md-5 greting-vid ">
                  <div className="card card-bg p-2">
                    <ReactPlayer
                      url={
                        greeting?.video
                          ?  videoCdnUrl + greeting?.video
                          : ""
                      }
                      width="100%" // height="100%" playing={false}
                      volume={1}
                      height="330px"
                      controls={true}
                      autoPlay
                    />
                  </div>
                </div>
              </div>

              <div className="my-3 row mx-2">
                <div className="col-md-7 mb-3">
                  <div className="card card-bg head-line mb-3">
                    <div className="text-light d-flex justify-content-center">
                      <h4 className="text-white p-2">
                        Greetings New Request List
                      </h4>
                    </div>
                  </div>
                  {currentItems.length !== 0 ? (
                    <>
                      <div className="row">
                        <div className="card card-bg">
                          <div className=" NotifyOver w-100">
                          <table className="w-100 my-3 NotifyTable">
                              <thead>
                                <tr className="NotifyTableHeader mx-3">
                                  <th className="Notifyth text-center">Status</th>
                                  <th className="Notifyth">User</th>
                                  <th className="Notifyth">Date</th>
                                  <th className="Notifyth">Time</th>
                                  <th className="Notifyth">Purpose</th>
                                </tr>
                              </thead>
                              <tbody>
                                {currentItems.map((data, index) => (
                                  <tr key={index} className="NotifyTableRow mx-3 my-2">
                                    <td className="Notifytdx text-center align-middle lNTS">
                                      {data.notification_at ? (
                                        <span className="badge bg-success px-2 py-1">Notified</span>
                                      ) : (
                                        <input
                                          type="checkbox"
                                          className="form-check-input cursor-pointer"
                                          value={data.user?.id}
                                          checked={Checked.includes(data.user?.id)}
                                          onChange={() => handleCheckBox(data.user?.id, data.id)}
                                          style={{ transform: "scale(1.2)", margin: "5px" }}
                                        />
                                      )}
                                    </td>
                                    <td className="Notifytdx d-flex align-items-center">
                                      <img
                                        src={
                                          data.user?.image != null
                                            ? imageCdnUrl + data.user?.image
                                            : noImage
                                        }
                                        className="NotifyAimg rounded-circle"
                                        alt="profile"
                                      />
                                      <span className="ml-2">
                                        {data.user?.first_name} {data.user?.last_name}
                                      </span>
                                    </td>
                                    <td className="Notifytdx">{moment(data.request_time).format("LL")}</td>
                                    <td className="Notifytdx">{moment(data.request_time).format("LT")}</td>
                                    <td className="Notifytdx rNTS">{data.purpose}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            <div className="button mx-5 mb-5">
                              {Checked.length > 0 ? (
                                <button
                                  className="btn btn-warning bg-warning mt-3  NotiBtnts"
                                  variant="primary"
                                  onClick={() => setModalShowl(true)}
                                >
                                  <i className="fas fa-bell"></i> Notify
                                </button>
                              ) : (
                                ""
                              )}
                              <NotifyModalAdmin
                                show={modalShowl}
                                onHide={() => setModalShowl(false)}
                                users_id={Checked}
                                setModalShowl={setModalShowl}
                                setGreetingList={setGreetingList}
                                greeting_id={greeting?.id}
                                greetings_reg_id={regGreId}
                                setChecked={setChecked}
                                getAllGreetingReg={getAllGreetingReg}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="react-paginate">
                          <ReactPaginate
                            breakLabel="..."
                            nextLabel="next >"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={3}
                            pageCount={pageCount}
                            previousLabel="< previous"
                            renderOnZeroPageCount={null}
                            breakLinkClassName={"page-link"}
                            containerClassName={"pagination"}
                            pageLinkClassName={"page-link"}
                            previousLinkClassName={"page-link"}
                            nextLinkClassName={"page-link"}
                            activeClassName={"active"}
                          />
                        </div>
                    </>
                  ) : (
                    <>
                      <div className="row justify-content-center align-items-center">
                        <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                          <img src={Nodata} alt="" className=" Nodata" />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="col-md-5">
                  <div className="card card-bg px-3 py-4">
                    <div className="card card-bg head-line mb-2">
                      <div className="text-light d-flex justify-content-center p-2">
                        <div className="faTrophy">
                          <i className="fas fa-trophy"></i>
                        </div>
                        <h4 className="mx-3 text-white p-2">
                          {greeting?.title}
                        </h4>
                      </div>
                    </div>

                    <p className="text-light pt-1">
                      <Markup content={greeting?.instruction} />
                    </p>
                  </div>
                  <div className="row d-flex flex-wrap">
                    <div className="col-md-12">
                      <div
                        className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                        style={{ width: "100%" }}
                      >
                        <span>
                          <img src={PriceTag} alt="" className="PriceTage" />
                        </span>
                        <div className=" mx-2 ">
                          <span className="text-light buTon-ab ">Cost</span>
                          <br></br>
                          <span className="text-info fw-bold buTon-abc">
                            {greeting?.cost} $
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                        style={{ width: "100%" }}
                      >
                        <span>
                          <img src={PriceTag} alt="" className="PriceTage" />
                        </span>
                        <div className=" mx-2 ">
                          <span className="text-light buTon-ab ">
                            Minimum apply before
                          </span>
                          <br></br>
                          <span className="text-info fw-bold buTon-abc">
                            {greeting?.user_required_day} Day
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row justify-content-center align-items-center mx-2">
                <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                  <img src={Nodata} alt="" className=" Nodata" />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default NotifyGreetingsContent;
